import moment from "moment-timezone";
import { FORMATS } from "../core/formats";
import { CoreUtils } from "../core";
export const OrderUtils = {
    getOrderManagementStatus(o, tz) {
        if (o.status !== "confirmed") {
            return o.status;
        }
        const due = this.dueInMillis(o, tz);
        if (due < CoreUtils.dates.getMillisFromMinutes(120)) {
            return "due_soon";
        }
        return "upcoming";
    },
    dueInMillis(o, tz) {
        if (o.ready_in && o.ready_in.timestamp) {
            return o.ready_in.timestamp - Date.now();
        }
        if (o.config.due === "later") {
            if (o.config.timestamp) {
                return o.config.timestamp - Date.now();
            }
            const dueMilli = moment.tz(`${o.config.date} ${o.config.time}`, FORMATS.moment.datetime, tz).valueOf();
            return dueMilli - Date.now();
        }
        return 0;
    },
    icon(service) {
        switch (service) {
            case "pickup":
                return "shopping-bag";
            case "delivery":
                return "motorcycle";
            case "dine_in":
                return "utensils";
            case "table_booking":
                return "calendar-alt";
            default:
                return "shopping-bag";
        }
    },
    sortByDue(tz) {
        return (a, b) => {
            const dueA = this.dueInMillis(a, tz);
            const dueB = this.dueInMillis(b, tz);
            if (dueA < dueB) {
                return -1;
            }
            else if (dueA > dueB) {
                return 1;
            }
            return 0;
        };
    },
    sortByCreated(a, b) {
        if (a.created < b.created) {
            return -1;
        }
        else if (a.created > b.created) {
            return 1;
        }
        return 0;
    },
    sortByUpdated(a, b) {
        if (a.updated && b.updated) {
            if (a.updated > b.updated) {
                return -1;
            }
            else if (a.updated < b.updated) {
                return 1;
            }
            return 0;
        }
        return this.sortByCreated(a, b);
    },
    sortFunctionByStatus(s, tz) {
        if (["unconfirmed"].indexOf(s) !== -1) {
            return this.sortByCreated;
        }
        else if (["complete", "cancelled"].indexOf(s) !== -1) {
            return this.sortByUpdated;
        }
        return this.sortByDue(tz);
    },
    checkBlockedAddresses(destination, block) {
        block = block || [];
        if (block.length > 0) {
            for (const a of block) {
                if (a !== "") {
                    if (destination.toLowerCase().indexOf(a.toLowerCase()) !== -1) {
                        return true;
                    }
                }
            }
        }
        return false;
    },
    getTrackingUrl(order) {
        if (order.config.service !== 'delivery') {
            return '';
        }
        const provider = order.config.delivery_provider;
        if (!provider) {
            return '';
        }
        if (provider === 'postmates') {
            return order.config.postmates_tracking_url || '';
        }
        if (provider === "lalamove") {
            return order.config.lalamove_share_link || '';
        }
        if (provider === 'tookan') {
            return order.config.tookan_delivery_tracking || '';
        }
        return '';
    },
    getReturnTrackingUrl(order) {
        if (order.config.service !== 'delivery') {
            return '';
        }
        const provider = order.config.delivery_provider;
        if (!provider) {
            return '';
        }
        if (provider === 'postmates') {
            return order.config.postmates_returning_tracking_url || '';
        }
        return '';
    },
    hasDeliveryError(order) {
        if (order.config.service !== 'delivery') {
            return false;
        }
        const provider = order.config.delivery_provider;
        if (!provider) {
            return false;
        }
        if ((provider === 'postmates' && order.config.postmates_error) ||
            (provider === 'questtag' && order.config.questtag_error) ||
            (provider === 'tookan' && order.config.tookan_error) ||
            (provider === 'lalamove' && order.config.lalamove_error)) {
            return true;
        }
        return false;
    },
    getDeliveryStatusFromProvider(order) {
        if (order.config.service !== 'delivery') {
            return '';
        }
        const provider = order.config.delivery_provider;
        if (!provider) {
            return '';
        }
        if (provider === 'lalamove') {
            return order.config.lalamove_order_status || '';
        }
        return '';
    },
};
//# sourceMappingURL=index.js.map